var map = {
	"./csp/dark/rancher-logo.svg": 1909,
	"./federal/dark/rancher-logo.svg": 85532,
	"./rgs/dark/rancher-logo.svg": 47571,
	"./suse/dark/rancher-logo.svg": 73651
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57704;